// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compact } from 'lodash';
import SecurityDashboardsDetailList from './SecurityDashboardsDetailList';
// css
import '../../styles/components/analytics/SecurityDashboardsOtherDetail.scss';


class SecurityDashboardsOtherDetail extends Component {

  renderCategories() {
    const { categories } = this.props;

    const chunks = [
      [categories[0]],
      [categories[1], categories[2], categories[3]]
    ].map(chunk => compact(chunk));

    return chunks.map((chunk, index) => (
      <div key={index} className='col-md-6'>
        {chunk.map((category, index) => (
          <SecurityDashboardsDetailList
            key={index}
            subcategory={category.subcategories[0]}
          />
        ))}
      </div>
    ));
  }

  render() {
    return (
      <div className='analytics__security-dashboards-other-detail' id='pptx_security_dashboards_other_detail'>
        <h2>Security Recommendation: Audit, Search, and Other Dashboards</h2>
        <div className='box'>
          <div className='row'>
            {this.renderCategories()}
          </div>
        </div>
      </div>
    );
  }
}

SecurityDashboardsOtherDetail.propTypes = {
  categories: PropTypes.array.isRequired
};

export default SecurityDashboardsOtherDetail;



// WEBPACK FOOTER //
// ./src/components/analytics/SecurityDashboardsOtherDetail.js